import { Point } from '../../services/ekispert/models';
import { Prefecture } from '../../services/ekispert/models/operationLinePattern';
import { Type } from '../../services/ekispert/models/stationLight';
import { PointType } from '../../states/common';
import { convertEWSToLocation, GeoLocation } from '../../utils/geoLocation';

// オートコンプリートで表示する候補のクラス。
export class Candidate {
  name: string;
  code: string;
  type: string;
  geoPoint?: GeoLocation;
  prefecture?: Prefecture;
  description?: string;

  /**
   * constructor
   * @param name 地点名
   * @param code 駅コード
   * @param type 地点種別
   * @param geoPoint 地点緯度経度情報
   * @param prefecture 都道府県情報
   * @param description 備考（住所）
   */
  constructor(name: string, code: string, type: string | Type, geoPoint?: GeoLocation | null, prefecture?: Prefecture | null, description?: string) {
    this.name = name;
    this.code = code;
    // stringの場合はそのまま採用し、バスの場合は1階層深いオブジェクトのため分岐している。
    this.type = typeof type === 'string' ? type : type.text;
    if(geoPoint) {
      this.geoPoint = geoPoint;
    }
    if(prefecture) {
      this.prefecture = prefecture;
    }
    if(description) {
      this.description = description;
    }
  }

  static convertPointToCandidate(point: Point) {
    return new Candidate(point.Station.Name, point.Station.code, point.Station.Type, convertEWSToLocation(point.GeoPoint), point.Prefecture);
  }

  /** 候補リストで表示する各種別に応じたラベルを取得する。 */
  getTypeLabel(t: any) {
    switch (this.type) {
      // 現在地の場合。
      case 'currentPosition':
        // 空文字にすることで見出し（背景色つきの部分）は非表示とする。
        return '';
      // 鉄道の場合。
      case 'train':
        return t('station');
      // 施設・地点（Google Places APIから取得した候補）の場合。
      case 'place':
        return t('place');
      // バスの場合。
      case 'bus':
        return t('bus_stop');
      // 船の場合。
      case 'ship':
        return t('port');
      // 履歴の場合。
      case PointType.HISTORY:
        return  t('search:history') + t('search:history_limit');
      // それ以外は空文字を返す。
      default:
        return '';
    }
  }
}
